// eslint-disable-next-line import/prefer-default-export
export function hasPrefixSuffix(props) {
  return !!(props.prefix || props.suffix || props.allowClear);
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/antd/es/input/utils.js
// module id = 2678
// module chunks = 0